import { render, staticRenderFns } from "./ServicioTipos.vue?vue&type=template&id=6ee6742e"
import script from "./ServicioTipos.vue?vue&type=script&lang=js"
export * from "./ServicioTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports